import dynamic from 'next/dynamic';

const Implementation = dynamic(
  () => import('./mobile-chat-history-drawer-implementation'),
  { ssr: false }
);

export const MobileChatHistoryDrawer = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => (open ? <Implementation onClose={onClose} /> : null);
